// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginDialog-module__container--wimeL {
  box-sizing: border-box;
  width: min(calc(100% - 48px), 450px);
  padding: 64px 32px;
}

.LoginDialog-module__loginButtons--D1rGR {
  width: 100%;
  margin-top: 40px;
}

@media (max-width: 480px) {
  .LoginDialog-module__container--wimeL {
    padding-inline: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LoginPage/dialog/LoginDialog/LoginDialog.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".container {\n  box-sizing: border-box;\n  width: min(calc(100% - 48px), 450px);\n  padding: 64px 32px;\n}\n\n.loginButtons {\n  width: 100%;\n  margin-top: 40px;\n}\n\n@media (max-width: 480px) {\n  .container {\n    padding-inline: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LoginDialog-module__container--wimeL`,
	"loginButtons": `LoginDialog-module__loginButtons--D1rGR`
};
export default ___CSS_LOADER_EXPORT___;
